/* eslint-disable */
import React, { Component } from "react";
import PreviewLinkForm from "./PreviewLinkForm";

import connectToDatoCms from "./connectToDatoCms";
import "./style.sass";
@connectToDatoCms(plugin => ({
  developmentMode: plugin.parameters.global.developmentMode,
  fieldValue: plugin.getFieldValue(plugin.fieldPath)
}))
export default class Main extends Component {
  render() {
    const {
      itemId: ITEM_ID,
      itemValue: Item_Value,
      itemType: {
        attributes: { api_key: MODEL_TYPE }
      }
    } = this.props.plugin._settings;
    console.log("Props: ", this.props);
    return (
      <div className="container">
        <div className="container__item-id">ITEM_ID: {ITEM_ID}</div>
        <PreviewLinkForm
          ITEM_ID={ITEM_ID}
          MODEL_TYPE={MODEL_TYPE}
          Item_Value={Item_Value}
        />
      </div>
    );
  }
}
